import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'inline-block',
  },
  error: {
    '& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused, & .MuiInputBase-input': {
      color: theme.color.reds[100],
    },
    '& .MuiInput-root.MuiInputBase-root': {
      border: `2px solid ${theme.color.reds[100]}`,
    },
    '& .MuiInputBase-root.MuiAutocomplete-inputRoot': {
      border: 0,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.color.reds[100],
      },
    },
    '& .mobile-autocomplete': {
      borderColor: theme.color.reds[100],
    },
    '& .MuiFormControl-root:after': {
      backgroundColor: theme.color.reds[100],
    },
    '& input': {
      color: theme.color.reds[100],
    },
    '& .react-tel-input .form-control': {
      borderColor: theme.color.reds[100],

      '& + div': {
        borderColor: theme.color.reds[100],
      },
    },
    '& .MuiIconButton-label': {
      '& rect': {
        stroke: theme.color.reds[100],
      },
    }
  },
}), { name: 'FormElementWrapper' });
